import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

// 获取权限
export type FabricUtilsGetPermissionOptions = { type: 'camera' | 'microphone' };

export type FabricUtilsGetPermissionApi = (
  options: FabricUtilsGetPermissionOptions
) => Promise<{}>;

/**
 * 获取权限
 * @param options { type: 'camera' | 'microphone' }
 * @returns {}
 */
export const getPermission: FabricUtilsGetPermissionApi = (
  options: FabricUtilsGetPermissionOptions
) => {
  return new Promise<boolean>((resolve, reject) => {
    core.call<
      'fabric_utils.getPermission',
      FabricUtilsGetPermissionOptions,
      boolean
    >('fabric_utils.getPermission', options, (result) => {
      const fabricErrors = filterFabricErrors(
        result.code,
        result.message,
        result.data
      );
      if (fabricErrors) {
        reject(fabricErrors);
      } else {
        resolve(result.data);
      }
    });
  });
};
